/**
 * V14.93 — Bus d'événements léger entre la galerie / le wizard et le lanceur :
 * quand une référence d'étape change (validation, ancre, refus), le lanceur
 * recharge sa config et passe à l'étape suivante sans rafraîchir la page.
 */
import { useEffect, useState } from 'react';

export const REFS_CHANGED_EVENT = 'pu:generation-refs-changed';

export const STAGE_ORDER = ['whitebox', 'textured', 'furnished', 'final'];
export const nextStageOf = (stage) => STAGE_ORDER[STAGE_ORDER.indexOf(stage) + 1] || null;

/** detail : { lotId, stage, anchored (bool), nextStage } */
export const emitRefsChanged = (detail = {}) => {
  const d = { ...detail, nextStage: detail.nextStage ?? (detail.anchored ? nextStageOf(detail.stage) : null) };
  window.dispatchEvent(new CustomEvent(REFS_CHANGED_EVENT, { detail: d }));
};

export const useRefsChanged = (handler) => {
  useEffect(() => {
    const fn = (e) => handler?.(e.detail || {});
    window.addEventListener(REFS_CHANGED_EVENT, fn);
    return () => window.removeEventListener(REFS_CHANGED_EVENT, fn);
  }, [handler]);
};

/* ------------------------------------------------------------------------ */
/* V14.94 — Paramètres ajustés dans le lanceur, partagés avec le wizard.     */
/* Le lanceur publie ses paramètres effectifs (config projet + ajustements) ; */
/* le wizard les lit pour lancer / prévisualiser et peut les patcher.         */
/* ------------------------------------------------------------------------ */
const LAUNCHER_PARAMS_EVENT = 'pu:launcher-params-changed';
const LAUNCHER_PATCH_EVENT = 'pu:launcher-params-patch';
export const RESET_PARAM = '__reset__';
let launcherParams = {};

export const publishLauncherParams = (params) => {
  launcherParams = params || {};
  window.dispatchEvent(new CustomEvent(LAUNCHER_PARAMS_EVENT, { detail: launcherParams }));
};

export const useLauncherParams = () => {
  const [p, setP] = useState(launcherParams);
  useEffect(() => {
    const fn = (e) => setP(e.detail || {});
    window.addEventListener(LAUNCHER_PARAMS_EVENT, fn);
    return () => window.removeEventListener(LAUNCHER_PARAMS_EVENT, fn);
  }, []);
  return p;
};

/** patch : { key: value } — value === RESET_PARAM remet la valeur de la config projet. */
export const patchLauncherParams = (patch) => {
  window.dispatchEvent(new CustomEvent(LAUNCHER_PATCH_EVENT, { detail: patch || {} }));
};

export const useLauncherPatch = (handler) => {
  useEffect(() => {
    const fn = (e) => handler?.(e.detail || {});
    window.addEventListener(LAUNCHER_PATCH_EVENT, fn);
    return () => window.removeEventListener(LAUNCHER_PATCH_EVENT, fn);
  }, [handler]);
};
